var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"row banner"},[_vm._v("\n\tLorem ipsum dolor sit amet, consectetur adipisicing elit. Eligendi in quod fuga quibusdam illum earum sunt officia nemo doloribus dolor, ea voluptas voluptates minus, eveniet rerum, id cum. Cumque, rem.\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a0cfc40","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/components/Banner/Banner.component.html
// module id = null
// module chunks = 